import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import PopupForm from "../components/PopupForm";
import FloatingBar from "../components/FloatingBar";
import AreaCarousel from "../components/AreaCarousel";
import ContactCards from "../components/ContactCards";
import WhyChooseUs from "../components/WhyChooseUs";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Booking from "../components/Booking";
import Reviews from "../components/Reviews";

export default function Ramgarh() {
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        const visited = localStorage.getItem("ro_first_visit");
        if (!visited) {
            setTimeout(() => setShowPopup(true), 3000);
            localStorage.setItem("ro_first_visit", "true");
        }
    }, []);

    return (
        <>
            <Helmet>
                <title> RO Service Ramgarh @ 9031062015 | Water Purifier Repair & Services</title>
                <meta
                    name="description"
                    content="Same day RO water purifier repair, installation & AMC services in Ramgarh. Call or WhatsApp now for fast service."
                />
                <meta name="keywords" content="ro service, water purifier service in Ramgarh, ro repair, ro service near me, water purifier service near me, RO Service Ramgarh, RO Service Ramgarh near me, ro service centre, ro service centre in Bihar" />
                <meta name="keywords" content="ro service in Ramgarh" />
                <meta name="keywords" content="Water purifier service in Ramgarh" />
                <meta name="keywords" content="ro repair in Ramgarh" />
                <meta name="author" content="Wappotix Pvt Ltd" />
                <meta name="description" content="RO Service Ramgarh: We are India's leading RO water purifier repair and maintanance service provider of all brands like Kent, Pureit, Livpure, Aqua Guard, Aqua Fresh etc. RO repair service in Ramgarh" ></meta>
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "LocalBusiness",
                        name: "RO Service Center",
                        areaServed: Ramgarh,
                        telephone: "9031062015",
                        serviceType: "RO Water Purifier Repair"
                    })}
                </script>
            </Helmet>

            <Hero title=" Ramgarh" number="9031062015" />
            <Services />
            <Booking />
            <WhyChooseUs />
            <Reviews />
            <AreaCarousel />
            <ContactCards title=" Ramgarh" number="9031062015" mapiframe="https://www.google.com/maps?q=Ramgarh,Jharkhand,India&output=embed" />
            <FloatingBar />
            <PopupForm show={showPopup} onClose={() => setShowPopup(false)} />
        </>
    );
}